
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/__stores__",
      function () {
        return require("private-next-pages/__stores__/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/__stores__"])
      });
    }
  